/* AI Agent làm theo chỉ thị của anh Hoá — 2026-11-03 VN — WEB-20261103-SIZEROW (NHÁP đề xuất, chưa live)
   1) Nút trên ảnh "Personalize yours" (tạo bởi sz-pvl.js) -> chữ "Personalize"; bấm = cuộn tới ô nhập tên đầu tiên + focus
      (trước: mở popup preview Customily). Không có ô nhập -> giữ hành vi cũ.
   2) Hàng Size: ": L" cập nhật theo size đang chọn.
   3) Popup Size guide (nội dung page size-chart-*): pill inches/cm ngay dưới tiêu đề (gọi openOption gốc), bảng của Style đang chọn
      lên đầu, bảng trước ảnh, tô hàng size đang chọn, ±5% xuống cuối. Nội dung page không đổi. */
(function () {
  if (window.__szSizeRow) return; window.__szSizeRow = 1;
  var D = document;
  function optVal(re) {
    var sw = D.querySelectorAll('.product__details--product-page .swatch, .swatch');
    for (var i = 0; i < sw.length; i++) {
      var t = sw[i].querySelector('.option_title');
      if (!t || !re.test((t.firstChild && t.firstChild.textContent || t.textContent).trim())) continue;
      var c = sw[i].querySelector('input[type=radio]:checked');
      if (c) return c.value;
    }
    return '';
  }
  function sizeVal() { return optVal(/^size/i); }
  function styleVal() { return optVal(/^style/i); }
  function styleNames() {
    var sw = D.querySelectorAll('.swatch'), out = [];
    for (var i = 0; i < sw.length; i++) {
      var t = sw[i].querySelector('.option_title');
      if (!t || !/^style/i.test((t.firstChild && t.firstChild.textContent || t.textContent).trim())) continue;
      Array.prototype.forEach.call(sw[i].querySelectorAll('input[type=radio]'), function (r) { out.push(r.value); });
      break;
    }
    return out;
  }
  function syncRow() {
    var v = sizeVal();
    Array.prototype.forEach.call(D.querySelectorAll('.szsr-val'), function (el) { var t = v ? ': ' + v : ''; if (el.textContent !== t) el.textContent = t; });
  }
  function soon() { setTimeout(syncRow, 0); setTimeout(syncRow, 150); }
  D.addEventListener('change', soon, true); D.addEventListener('click', soon, true);

  /* popup */
  var SEC = [[/youth/i, /YOUTH/], [/women|lady|ladies/i, /WOMEN/], [/hood/i, /HOODIE/], [/sweat/i, /SWEATSHIRT/], [/tee|t-?shirt/i, /STANDARD T-SHIRT|^.\s*T-SHIRT/]];
  function prep() {
    var m = D.querySelector('.pop-up-modal'); if (!m) return;
    var pc = m.querySelector('.pop-up-content'), sc = m.querySelector('.size-chart-content'); if (!pc || !sc) return;
    if (!m.classList.contains('szsr-ready')) {
      m.classList.add('szsr-ready');
      /* ±5% xuống cuối */
      var h = sc.querySelector(':scope > h3, :scope > h2, :scope > p');
      if (h && /±\s*5%|deviation/i.test(h.textContent)) { h.classList.add('szsr-note'); sc.appendChild(h); }
      /* mỗi section: dòng tiêu đề navy + kẻ đứt (section đầu có toggle cm | inches) */
      Array.prototype.forEach.call(sc.querySelectorAll('.container'), function (c) {
        var t = c.querySelector('.kw_title'); if (!t || c.__top) return;
        var top = D.createElement('div'); top.className = 'szsr-top';
        var s = D.createElement('span'); s.className = 'szsr-ttl';
        s.textContent = t.textContent.replace(/^\s*[A-Z]\.\s*/, '').toLowerCase().replace(/(^|[\s-])\w/g, function (x) { return x.toUpperCase(); });
        top.appendChild(s); c.parentNode.insertBefore(top, c); c.__topEl = top; c.__top = 1;
      });
      if (sc.querySelector('.ks-unit-toggle') && !m.__seg) {
        var u = D.createElement('div'); u.className = 'szsr-seg'; u.setAttribute('role', 'group'); u.setAttribute('aria-label', 'Unit');
        u.innerHTML = '<button type="button" data-u="cm">cm</button><button type="button" data-u="inches" class="is-on">inches</button>';
        u.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          var ob = sc.querySelector('.ks-unit-toggle-label.' + b.getAttribute('data-u')); if (ob) ob.click(); else if (window.openOption) window.openOption(e, b.getAttribute('data-u'));
          Array.prototype.forEach.call(u.children, function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
        m.__seg = u;
      }
      var hd = pc.querySelector('.szsg-title'); if (hd) hd.textContent = 'Size & Fit Info';
      /* bottom-sheet mobile: thanh keo + vuot xuong de dong */
      var grip = D.createElement('div'); grip.className = 'szsr-grip'; pc.insertBefore(grip, pc.firstChild);
      var y0 = null, dy = 0;
      function mob() { return window.innerWidth <= 749; }
      function ts(e) { if (!mob()) return; y0 = e.touches[0].clientY; dy = 0; pc.style.transition = 'none'; }
      function tm(e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); pc.style.transform = 'translateY(' + dy + 'px)'; }
      function te() {
        if (y0 === null) return; y0 = null; pc.style.transition = '';
        if (dy > 80) { var cb = pc.querySelector('.close-button'); pc.style.transform = ''; if (cb) cb.click(); }
        else pc.style.transform = '';
        dy = 0;
      }
      [grip, pc.querySelector('.szsg-head')].forEach(function (el) { if (!el) return; el.addEventListener('touchstart', ts, { passive: true }); el.addEventListener('touchmove', tm, { passive: true }); el.addEventListener('touchend', te); el.addEventListener('touchcancel', te); });
    }
    /* tab con: moi Style cua SP co bang -> 1 tab; tab active mac dinh = Style dang chon tren PDP */
    var cs = sc.querySelectorAll('.container'), curC = null, tabs = [];
    function cOf(name) { for (var i = 0; i < SEC.length; i++) { if (!SEC[i][0].test(name)) continue; for (var j = 0; j < cs.length; j++) { var t = cs[j].querySelector('.kw_title'); if (t && SEC[i][1].test(t.textContent)) return cs[j]; } break; } return null; }
    curC = cOf(styleVal());
    styleNames().forEach(function (n) { var c = cOf(n); if (c && !tabs.some(function (x) { return x.c === c; })) tabs.push({ c: c, n: n }); });
    if (!curC) curC = (tabs[0] && tabs[0].c) || cs[0];
    var old = sc.querySelector('.szsr-tabs'); if (old) old.parentNode.removeChild(old);
    var oldn = sc.querySelector('.szsr-now'); if (oldn) oldn.parentNode.removeChild(oldn);
    function label(c) { var t = c.__topEl && c.__topEl.querySelector('.szsr-ttl'); return t ? t.textContent : ''; }
    function show(c) {
      Array.prototype.forEach.call(cs, function (x) { var h = x !== c; x.classList.toggle('szsr-hide', h); if (x.__topEl) x.__topEl.classList.toggle('szsr-hide', h); });
      if (m.__seg && c.__topEl) c.__topEl.appendChild(m.__seg);
      var tb = sc.querySelector('.szsr-tabs');
      if (tb) Array.prototype.forEach.call(tb.children, function (b) { var on = b.__c === c; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var nw = sc.querySelector('.szsr-now'); if (nw) nw.hidden = (c === curC);
      sc.scrollTop = 0;
      if (tb) { var on = tb.querySelector(".is-on"); if (on && on.scrollIntoView) { try { on.scrollIntoView({ inline: "center", block: "nearest", behavior: first ? "auto" : "smooth" }); } catch (e) { on.scrollIntoView(); } } }
      first = false;
    }
    var first = true;
    if (tabs.length > 1) {
      var tb = D.createElement('div'); tb.className = 'szsr-tabs'; tb.setAttribute('role', 'tablist');
      tabs.forEach(function (x) {
        var b = D.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.textContent = label(x.c); b.__c = x.c;
        b.addEventListener('click', function () { show(x.c); }); tb.appendChild(b);
      });
      var nw = D.createElement('div'); nw.className = 'szsr-now'; nw.hidden = true;
      nw.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="7.6" r="1.1" fill="currentColor"/></svg><span></span>';
      nw.lastChild.textContent = "You\u2019re currently ordering: " + label(curC);
      sc.insertBefore(nw, sc.firstChild); sc.insertBefore(tb, nw);
    }
    show(curC);
    sc.scrollTop = 0;
    setTimeout(function () { first = true; show(curC); }, 60);
    return;
    /* tô hàng (đã bỏ) */
    var v = (sizeVal() || '').trim().toUpperCase();
    Array.prototype.forEach.call(sc.querySelectorAll('tr'), function (r) {
      var f = r.firstElementChild, on = !!(v && f && f.textContent.trim().toUpperCase() === v);
      r.classList.toggle('szsr-hl', on);
    });
    sc.scrollTop = 0;
  }
  D.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.trigger-pop-up')) { prep(); setTimeout(prep, 0); } }, true);

  /* nút Personalize trên ảnh */
  function nameInput() {
    var q = D.querySelectorAll('#customily-options input[type=text], .customily_option input[type=text], #cl_optionsapp input[type=text], .customily-wrapper input[type=text], .customall-wrapper input[type=text], .customily_option textarea');
    for (var i = 0; i < q.length; i++) if (q[i].offsetParent) return q[i];
    return null;
  }
  /* (3/11 PVSCROLL) bỏ handler capture cuộn tới ô nhập tên — nó stopImmediatePropagation làm nút Personalize now không cuộn tới hàng Style; giờ sz-pvl.js tryClick lo */
  var tries = 0;
  (function lbl() {
    var b = D.querySelector('.sz-pvt-try span');
    if (b) { b.parentNode.setAttribute('aria-label', 'Personalize your design'); }
    if (++tries < 60) setTimeout(lbl, 500);
  })();

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', syncRow); else syncRow();
})();


